module.exports = __webpack_public_path__ + "img/ic-cancel.f49f4dd2.svg";